/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlagCanadaLegacy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={26}
      height={13}
      viewBox='0 0 26 13'
      {...props}
    >
      <path fill='red' d='M0 0h26v13H0z' />
      <path fill='#FFF' d='M6.5 0h13v13h-13z' />
      <path
        fill='red'
        d='M13 1.219l-.887 1.654c-.101.18-.281.163-.461.063l-.642-.333.479 2.541c.101.464-.223.464-.382.264L9.985 4.153l-.182.637c-.021.084-.113.172-.251.151l-1.417-.298.372 1.353c.08.301.142.426-.081.505l-.505.238 2.439 1.982a.317.317 0 01.111.331l-.213.7c.84-.096 1.592-.242 2.433-.332.074-.008.199.115.198.201l-.111 2.566h.409l-.064-2.562c0-.086.112-.214.187-.206.84.09 1.592.236 2.432.332l-.213-.7a.317.317 0 01.111-.331l2.439-1.982-.506-.238c-.222-.079-.16-.204-.08-.505l.372-1.353-1.417.298a.218.218 0 01-.252-.151l-.182-.637-1.121 1.254c-.159.201-.482.201-.381-.264l.479-2.541-.643.333c-.18.101-.36.117-.461-.063'
      />
    </svg>
  );
}

export default SvgFlagCanadaLegacy;
